import { IconProps } from './type';

export const ICCar: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 256 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M18 82C30 66 50 57 76 57H95C112 44 130 36 154 36C185 36 214 50 232 59L244 58C247 58 249 61 247 64L241 74C244 80 244 89 239 96C232 105 217 108 198 108H58C39 108 25 105 18 98C15 94 15 87 18 82Z"
                fill="#4f4b5c"
            />
            <path
                d="M107 56C122 45 136 40 156 40C177 40 197 47 215 55C195 58 146 59 107 56Z"
                fill="white"
            />
            <path
                d="M28 78C35 71 44 68 57 67C51 76 40 81 28 82V78Z"
                fill="#a797ff"
            />
            <path
                d="M205 70L238 66L232 76C224 77 214 75 205 70Z"
                fill="#a797ff"
            />
            <path
                d="M93 91C121 87 153 81 188 73C177 90 163 97 139 98H91C88 98 87 92 93 91Z"
                fill="#a797ff"
            />
            <circle cx="70" cy="103" r="18" fill="#a797ff" />
            <circle cx="70" cy="103" r="11" fill="#4f4b5c" />
            <circle cx="203" cy="103" r="18" fill="#a797ff" />
            <circle cx="203" cy="103" r="11" fill="#4f4b5c" />
        </svg>
    );
};
